import {SiOpenaigym} from 'react-icons/si'
import cgiMovie1 from './videos/SBTH2.mp4'
import cgiMovie2 from './videos/Rotai.mp4'
import cgiMovie3 from './videos/Double_Cove_Rogers.mp4'
import cgiMovie4 from './videos/SHK_Book.mp4'
import cgiMovie5 from './videos/CullinanLogo.mp4'
import cgiMovie6 from './videos/Trinity_Park.mp4'
import cgiMovie7 from './videos/South_Bay.mp4'
import cgiMovie8 from './videos/MassMutual.mp4'
import cgiMovie9 from './videos/Glad.mp4'
import cgiMovie10 from './videos/OceanPark.mp4'
import cgiMovie11 from './videos/Blue_Girl.mp4'

import cgiMovie13 from './videos/TheFinnie.mp4'
import cgiMovie14 from './videos/Green_Hong_Kong.mp4'
import cgiMovie15 from './videos/Henderson_Corporate_Video.mp4'

export const links = [
    {
        name: "HOME",
        path: '/'
    },
    {
        name: "ABOUT",
        path: '/about'
    },
    {
        name: "PROJECTS",
        path: '/projects',
        children: [
            {
                name: "CGI",
                path: '/projectscgi'
            },
            {
                name: "CONFIGURATORS (Coming Soon)",
                path: '/projectsconfigurators_'
            },
            {
                name: "INTERACTIVE MEDIA (Coming Soon)",
                path: '/projectsinteractives_'
            },
            {
                name: "VR/AR (Coming Soon)",
                path: '/projectsvrar_'
            }
        ]
    },
    {
        name: "SERVICES",
        path: '/services',
        children: [
            {
                name: "CGI",
                path: '/servicescgi'
            },
            {
                name: "CONFIGURATORS",
                path: '/servicesconfigurators'
            },
            {
                name: "INTERACTIVE MEDIA",
                path: '/servicesinteractives'
            },
            {
                name: "VR APPS",
                path: '/servicesvr'
            },
            {
                name: "AR APPS",
                path: '/servicesar'
            },
        ]
    },
    {
        name: "CONTACT",
        path: '/contact'
    }
]


export const projectscat = [
    {
        name: "CGI",
        path: '/projects/cgi'
    },
    {
        name: "Configurators(Coming Soon)",
        path: '/projects/configurators_'
    },
    {
        name: "Interactive Media(Coming Soon)",
        path: '/projects/interactives_'
    },
    {
        name: "VR/AR(Coming Soon)",
        path: '/projects/vrar_'
    },
]


export const projectsCgiData = [
    {
        index: 11,
        title: "CGI",
        name: "The Finnie TVC",
        description: "",
        movie: cgiMovie13,
        mwidth: 460,
        mheight: 230,
        image: require("./images/TheFinnie.png"),
    },
    {
        index: 12,
        title: "CGI",
        name: "Green Hong Kong TVC",
        description: "",
        movie: cgiMovie14,
        mwidth: 460,
        mheight: 230,
        image: require("./images/Green_Hong_Kong.png"),
    },
    {
        index: 13,
        title: "CGI",
        name: "Henderson Corporate Video TVC",
        description: "",
        movie: cgiMovie15,
        mwidth: 460,
        mheight: 230,
        image: require("./images/Henderson_Corporate_Video.png"),
    },
    {
        index: 0,
        title: "CGI",
        name: "Star By The Harbour TVC",
        description: "",
        movie: cgiMovie1,
        mwidth: 460,
        mheight: 230,
        image: require("./images/SBTH2.png"),
    },
    {
        index: 1,
        title: "CGI",
        name: "Rotai TVC",
        description: "",
        movie: cgiMovie2,
        width: 460,
        height: 230,
        image: require("./images/Rotai.png"),
    },
    {
        index: 2,
        title: "CGI",
        name: "Double Cove Rogers Threatre Video",
        description: "",
        movie: cgiMovie3,
        width: 840,
        height: 282,
        image: require("./images/Double_Cove_Rogers.png"),
    },
    {
        index: 3,
        title: "CGI",
        name: "SHK Anniversary Video",
        description: "",
        movie: cgiMovie4,
        width: 840,
        height: 282,
        image: require("./images/SHK_Book.png"),
    },
    {
        index: 4,
        title: "CGI",
        name: "Cullinan Logo Video",
        description: "",
        movie: cgiMovie5,
        width: 460,
        height: 230,
        image: require("./images/CullinanLogo.png"),
    },
    {
        id: 5,
        categary: "CGI",
        title: "Trinity Park TVC",
        description: "",
        movie: cgiMovie6,
        width: 460,
        height: 230,
        projectlink: "/projectscgi",
        image: require("./images/Trinity_Park.png")
    },
    {
        id: 6,
        categary: "CGI",
        title: "South Bay TVC",
        description: "",
        movie: cgiMovie7,
        width: 460,
        height: 230,
        projectlink: "/projectscgi",
        image: require("./images/South_Bay.png")
    },
    {
        id: 7,
        categary: "CGI",
        title: "MassMutual TVC",
        description: "",
        movie: cgiMovie8,
        width: 460,
        height: 230,
        projectlink: "/projectscgi",
        image: require("./images/MassMutual.png")
    },
    {
        id: 8,
        categary: "CGI",
        title: "Glad TVC",
        description: "",
        movie: cgiMovie9,
        width: 460,
        height: 230,
        projectlink: "/projectscgi",
        image: require("./images/Glad.png")
    },
    {
        id: 9,
        categary: "CGI",
        title: "Ocean Park TVC",
        description: "",
        movie: cgiMovie10,
        width: 460,
        height: 230,
        projectlink: "/projectscgi",
        image: require("./images/OceanPark.png")
    },
    {
        id: 10,
        categary: "CGI",
        title: "Blue Girl TVC",
        description: "",
        movie: cgiMovie11,
        width: 460,
        height: 230,
        projectlink: "/projectscgi",
        image: require("./images/Blue_Girl.png")
    },
]


export const servicesData = [
    {
        index: 0,
        title: "CGI",
        description: "No need to visit an app store. Web apps allows your customers to experience and discover services on a desktop or mobile. ",
        children: [
            {
                feature: "3D modeling and animation",
                feature_description: "We offer 3D modeling and animation services to help companies create engaging, immersive experiences for their customers. Whether you need to create product demonstrations, virtual tours or other types of 3D content, we have the know-how to deliver."
            },
            {
                feature:"Live Action",
                feature_description: "CGI is completed through the production of visual effects, and it corresponds to the post-production process after filming in the production process of advertisement. We derives creative planning and ideas for advertisement, and proposes technical elements for production. In addition, the filmed video is corrected and synthesized with the VFX tool, and 3D CG production is added if necessary."
            },
            {
                feature:"Creative Design",
                feature_description: "Creative works are drawn by professional designers utilizing their diverse experience in motion graphic. We works in tandem with the most outstanding designer, artists, and art director, and carry on the most reasonable process, from planning in preconference with clients through final completion."
            },
            {
                feature: "Cinematic VFX",
                feature_description: "Based on various experience of projects for years, we have built reliable production pipeline and system to commit to clients. VFX team specializes in the best quality of outcomes for advertising, films, animation, and cinematic."
            },
            {
                feature: "Realtime Content",
                feature_description: "We proposes and produces immersive content in various areas to customers based on our Real-time engine. The real-time engine is positioning itself as a hub leading to the 4th industrial revolution in the creative content industry. This is because that interactive contents can be implemented through various input devices, data-based dynamic contents can be produced by connecting sensor devices, etc"
            },
            {
                feature: "3D product representation",
                feature_description: "We create 3D representation of your real product."
            }
        ],
        industries: [
        ],
        path: "/servicescgi",
        image: require("./images/cgi.png"),
        black: false
    },
    {
        index: 1,
        title: "Configurators",
        description: "The configuration platform allows you to visualize and sell your entire product catalog in 3D. ",
        children: [
            {
                feature: "Real time rendering & interaction",
                feature_description: "To prepare a good user experience, we take into account conditions such as sitting or standing, one-button interaction for new users, optimal field of view etc."
            },
            {
                feature:"Advanced light rendering",
                feature_description: "A realistic look is important to us and our customers. Our own multiple scene lighting pipeline ensures that all models are properly lit on every platform (Oculus Quest, Mobile phones)."
            },
            {
                feature:"Cost efficiency",
                feature_description: "Serverless, minimum-cost hosting with Kronos super compression maximizes app loading speed and efficiency."
            },
            {
                feature: "Advanced occlusion culling",
                feature_description: "We bake each scene for visibility and use this data to inform the renderer on how to save CPU and GPU time. Combined with the addition of view frustum culling, this has given us an almost 50% increase in performance."
            },
            {
                feature: "Content implementation",
                feature_description: "From cars and bikes to furniture and houses, our configurators help you boost sales regardless of the type of goods you sell. Our designers create detailed 3D models based on photos, illustrations and even draft sketches, while UI/UX experts plan the layout of the expanded data for convenient display on any mobile or desktop device."
            },
            {
                feature: "Regular content updates and maintenance",
                feature_description: "Regardless of the project’s scope, the work doesn’t end with publication. Our apps are supported long after release with optimisations, user interaction improvements and additional features. This guarantees that your app will grow with your business."
            }
        ],
        industries: [
            {
                head: "Modular houses",
                lines: "From artisan shops to next-generation Uber-like services, our one-stop software house can help you create an eCommerce application that will charm both business stakeholders and customers. At Prographers, we create powerful, scalable applications ready to serve millions of users worldwide. Our eCommerce IT solutions are seamless, secure and tailored to your individual business needs. See for yourself!"
            },
            {
                head: "Furniture and home goods",
                lines: "Thanks to the functionality of 3D graphics, our real estate apps help to create a believable illusion of comfort that can be the decisive point in closing the transaction. By customizing boring default products into individually decorated, cozy living spaces, you will help your clients make the right purchase."
            },
            {
                head: "Sport goods",
                lines: "As sports evolve, users’ expectations grow. Whether you want to check how ski pants will look with a jacket or check the look of new equipment on a bike, our solution will allow your users to match the optimal solution to their needs."
            },
            {
                head: "Electronics",
                lines: "With customers’ growing expectations for a variety of equipment, our configurators allow users to customize equipment such as cells, electric vehicles and many others, both in terms of appearance and technology, as well as selecting the right battery."
            },
            {
                head: "Automotive",
                lines: "With existing technologies, it was virtually impossible to present a car in any combination of versions, paintwork and finishes. With increasing customers’ expectations, we are meeting the boldest expectations in terms of graphics, optimization and usability."
            },
            {
                head: "Industrial",
                lines: "As professional equipment, such as agricultural machinery and professional construction equipment, uses more and more customization, we are faced with the challenge of mapping the visual image that is closest to the final product."
            },
        ],
        path: "/servicesconfigurators",
        image: require("./images/configurators.png"),
        black: true
    },
    {
        index: 2,
        title: "Interactive Media",
        description: "By adding technology and media, we create innovation in experience. ",
        children: [
            {
                feature: "Projection Mapping",
                feature_description: "Projection mapping is the projection of video material onto a 3D surface. With software, we ensure that the video material seamlessly aligns with the object it is projected onto as if it’s wearing a digital skin. Then, you can make it look the way you want."
            },
            {
                feature:"Interactive Wall",
                feature_description: "Interactive walls are real eye-catchers that make a significant impact. The wall and its design invite touch, and users are encouraged to explore everything on the wall through movements. Users discover videos, and sounds triggered by touching the interactive elements."
            },
            {
                feature:"Virtual Reality Experiences",
                feature_description: "Using VR to promote a brand or product at events. VR is a great way to make a lasting impact in an innovative way. By creating an experience, a brand leaves a bigger impression on the user. That’s already cool, but the VR experience was on display in the showroom for people to see."
            },
            {
                feature: "Real time rendering & interaction",
                feature_description: "To prepare a good user experience, we take into account conditions such as sitting or standing, one-button interaction for new users, optimal field of view etc."
            },
            {
                feature:"Advanced light rendering",
                feature_description: "A realistic look is important to us and our customers. Our own multiple scene lighting pipeline ensures that all models are properly lit on every platform (Oculus Quest, Mobile phones)."
            },
            {
                feature: "Regular updates and maintenance",
                feature_description: "Regardless of the project’s scope, the work doesn’t end with publication. Our apps are supported long after release with optimisations, user interaction improvements and additional features. This guarantees that your app will grow with your business."
            },
        ],
        industries: [
            {
                head: "Trade Show",
                lines: "Booth after cookie-cutter booth, Trade Shows tend to be a monotonous experience. Having your brand stand out has always been the goal - attract visitors, keep them engaged, and drive higher retention. Gamified experiences do just that. From large, immersive LED installations or personalized tablet experiences, Games help to drive traffic, capture leads, and measure important KPIs. By creating a game experience that illustrates and communicates your brand messaging, hitting your trade show goals becomes even easier."
            },
            {
                head: "Retail Experience",
                lines: "As retailers look to drive more customers to brick & mortar stores - the focus is on creating unique and focused experiences for the customer. From personalized shopping experiences to instagrammable interior designs - the competition is heating up. Adding gamification to the retail experience is one way to grab attention - but also an effective sales strategy."
            },
            {
                head: "Branded Corporate",
                lines: "Brand Game experiences are an important part of any well-rounded campaign because they translate your message to new mediums and audiences. Our target demographic seeks out interaction - to become part of the brand story. By communicating your campaign through a well-executed game concept, we have seen large increases in reach and engagement duration, both important to brand and message retention. Bring your entire campaign to life through integrated game experiences across all media channels."
            },
            {
                head: "Educational Gaming",
                lines: "Gaming, when done properly, has been proven to increase problem-solving & critical thinking skills, creativity, attention, and memory capacity. Games challenge you - they force you to make quick decisions, understand complex logic, and stay attentive. All of these benefits can be applied to educational and informational settings. From Pre-K and Young Adult engagement to corporate skills trainings, games are both a fun and functional way to keep your audience engaged and retaining as much information as possible."
            }
        ],
        path: "/servicesinteractives",
        image: require("./images/interactives.png"),
        black: true
    },
    {
        index: 3,
        title: "Virtual Reality",
        description: "Virtual reality is a simulated 3D environment that has scenes and objects which appear real. The user is able to immerse themselves in the environment and perceive stimuli as if they were in the real world.",
        children: [
            {
                feature: "VR accesibility",
                feature_description: "To prepare a good user experience, we take into account conditions such as sitting or standing, one-button interaction for beginners, optimum field of view, etc."
            },
            {
                feature: "Advanced light rendering",
                feature_description: "A realistic look is important to us and our customers. Our own multi-scene lighting pipeline ensures that all models are properly lit on every platform (Oculus Quest, mobile phones)."
            },
            {
                feature: "Seller assistance",
                feature_description: "The seller can join and manage the user session at any time. Helping users navigate, taking customers on a virtual tour."
            },
            {
                feature: "Web compatible",
                feature_description: "You can transfer your 3D experience from VR to the browser and back again, so you can share your experience around the world, even with people without VR glasses."
            },
            {
                feature: "Regular updates & content maintenance",
                feature_description: "Regardless of the project’s scope, the work doesn’t end with publication. Our apps are supported long after release with optimisations, user interaction improvements and additional features. This guarantees that your app will grow with your business."
            }
        ],
        industries: [
            {
                head: "Entertainment VR",
                lines: "From VR showrooms and product visualizations to furniture and car expositions, our VR apps help to present your product in the most immersive and engaging way at expositions, sales offices and showrooms."
            },
            {
                head: "Real estate VR apps",
                lines: "There is no better way to show a building than with a virtual tour. With the VR app, you can experience the true scale of the house 1:1 and the layout of the rooms as if you were really there."
            },
            {
                head: "Edtech",
                lines: "It’s not a great discovery that more immersive media affects the speed of learning. It wasn’t so long ago that text was replaced by video, and now video is being replaced by VR. So whether you want virtual training, research or maintenance guidance, our solution will meet your expectations."
            },
            {
                head: "Advertising",
                lines: "Not all ads have to be an ordinary experience. Whether you want to enrich your application with gamification or present it at a virtual event, we guarantee that thanks to VR and our know-how it will be an unforgettable experience."
            }
        ],
        path: "/servicesvr",
        image: require("./images/vr.png"),
        black: true
    },
    {
        index: 4,
        title: "Augmented Reality",
        description: "AR is a powerful immersive tool that modern businesses can use in their software products. Combining visuals, sounds and extended interactivity, AR is changing the way users receive information and interact with their environment.",
        children: [
            {
                feature: "Scene detection",
                feature_description: "Our AR apps scan the real-world environment with a camera lens, perceive the collected data as an image on a coordinate plane and translate it into a depth map to provide realistic 3D model placement."
            },
            {
                feature: "Image & object recognition",
                feature_description: "Along with understanding the scene, our AR apps can be trained to recognize specific 2D images and real 3D objects, then augment them with the relevant text or model data on the device screen."
            },
            {
                feature: "Motion tracking",
                feature_description: "Common to all smartphones and tablets, the GPS, gyroscope and accelerometer allow our AR apps to dynamically resize and calibrate on-screen augmentations as the user and their device move."
            },
            {
                feature: "Regular updates & content maintenance",
                feature_description: "It’s natural that the application’s metadata, 3D model database or image pool for automatic recognition needs to be changed and expanded over time. Because we always expect an ongoing and long-term cooperation, we offer continuous updates to your app content and help it grow as your business grows."
            },
            {
                feature: "Light estimation",
                feature_description: "Thanks to the intelligent light estimation algorithms, our AR applications can automatically adjust the lighting of the 3D model to naturally match the illumination scene in the camera lens."
            }
        ],
        industries: [
            {
                head: "Retail AR apps",
                lines: "From clothes and jewelry to furniture and cars, our AR applications for retail help boost sales regardless of the type of goods sold. Enter virtual fitting rooms and catalogues that allow 3D models of products to be virtually placed in the real world, offer AR-assisted navigation applications for supermarkets or create an entire virtual shop."
            },
            {
                head: "Real estate VR apps",
                lines: "With our virtual interior design function, our AR apps for real estate help create a believable illusion of comfort that can be the decisive point in closing the transaction. By transforming an empty and lifeless house or apartment into an individually furnished, cozy living space, you will assist your clients in making the right choices."
            },
            {
                head: "Edtech",
                lines: "AR Prographers training apps guide inexperienced specialists through product assembly, medical procedures, equipment installation, and other procedures, providing prompt text & visual tips. Such AR apps can support workplace education in various spheres, including manufacturing, construction, public services, healthcare, etc."
            },
            {
                head: "Advertising AR apps",
                lines: "AR helps you create marketing strategies that make a memorable impression on your audience. Overlay real-time live streaming with your sponsorship assets, install interactive AR screens in popular locations to improve brand recognition, or go beyond that and come up with your own creative AR advertising idea!"
            }
        ],
        path: "/servicesar",
        image: require("./images/ar.png"),
        black: false
    },
]


export const contactusdata = [
    {
        email: "madmonkstudio.design@gmail.com",
        messenger: "MadMonk",
        whatsapp: "+85293870293"
    },
    {
        email: "madmonkstudio.design@gmail.com",
        messenger: "MadMonk",
        whatsapp: "+85293870293"
    },
]


export const aboutusdata = [
    {
        id: 1,
        icon: require('./images/avatar1.png'),
        name: "Chanier Choi",
        title: "Executive Producer",
        description: "Chanier concerned with management accounting in all projects and associated with legal issues ,scripting, marketing, advisory and supervising capacities in the company.",
        email: "madmonkstudio.design@gmail.com"
    },
    {
        id: 2,
        icon: require('./images/avatar2.png'),
        name: "Andrew Lai",
        title: "Chief Technical Officer",
        description: "Andrew’s greatest strength lies in 3D rendering and optimization techniques. His attention to detail and exceptional communication skills allow him to develop state-of-the-art products perfectly tailored to the client’s needs.",
        email: "waichi38@@gmail.com"
    },
    {
        id: 3,
        icon: require('./images/avatar3.png'),
        name: "Michael Chan",
        title: "Chief Design Officer",
        description: "Michael’s extensive experience in working as a creative graphic and UX designer gives him a large spectrum of both functional and esthetic solutions, which are essential to building well-designed apps.",
        email: "madmonkstudio.design@gmail.com"
    }
]


export const useCases = [
    {
        id: 0,
        categary: "CGI",
        title: "Star By The Harbour TVC",
        description: "",
        movie: cgiMovie1,
        mwidth: 460,
        mheight: 230,
        projectlink: "/projectscgi",
        image: require("./images/SBTH2.png")
    },
    {
        id: 1,
        categary: "CGI",
        title: "Rotai TVC",
        description: "",
        movie: cgiMovie2,
        mwidth: 460,
        mheight: 230,
        projectlink: "/projectscgi",
        image: require("./images/Rotai.png")
    },
    {
        id: 2,
        categary: "CGI",
        title: "Cullinan Logo Video",
        description: "",
        movie: cgiMovie5,
        width: 460,
        height: 230,
        projectlink: "/projectscgi",
        image: require("./images/CullinanLogo.png")
    },
]


